import BasicPage from '@/pages/BasicPage/BasicPage';
import {
  CenterAlignedSectionHeader,
  ContentCards,
  ContentLink,
  ContentSectionHeader,
  Divider,
  LinkCards,
  NumberedLabelSectionHeader,
  Tooltip,
  Typography,
  InlineStateIndicator
} from 'br2s-ui-componentlibrary_r2_02';
import BuyInfoPage from '@/pages/BuyInfoPage/BuyInfoPage';
import SeoPage from '@/pages/SeoPage/SeoPage';
import InlineAlertAdapter from '@/components/InlineAlertAdapter/InlineAlertAdapter';
import AccordionAdapter from '../AccordionAdapter/AccordionAdapter';
import HelpSnippetAdapter from '../HelpSnippetAdapter/HelpSnippetAdapter';
import CarouselAdapter from '../CarouselAdapter/CarouselAdapter';
import InstructionIntroHeaderAdapter from '../InstructionIntro/InstructionHeader/InstructionHeaderAdapter';
import InstructionIntroDetailAdapter from '../InstructionIntro/InstructionDetails/InstructionDetailAdapter';
import CarouselPage from '@/pages/CarouselPage/CarouselPage';
import InstructionIntroPage from '@/pages/InstructionIntroPage/InstructionIntroPage';
import Richtext from '../Richtext/Richtext';
import FileSelector from '../FileSelector/FileSelector';
import Image from '../Image/Image';
import ScrollAnchor from '../ScrollAnchor/ScrollAnchor';

interface MgnlConfig {
  componentMappings: {};
}

const config: MgnlConfig = {
  componentMappings: {
    'br2s-react-lm:pages/basic-page': BasicPage,
    'br2s-react-lm:pages/buy-info-page': BuyInfoPage,
    'br2s-react-lm:pages/carousel-page': CarouselPage,
    'br2s-react-lm:pages/seo-page': SeoPage,
    'br2s-react-lm:pages/instruction-intro-page': InstructionIntroPage,
    'br2s-react-lm:components/accordion': AccordionAdapter,
    'br2s-react-lm:components/carousel': CarouselAdapter,
    'br2s-react-lm:components/center-aligned-section-header': CenterAlignedSectionHeader,
    'br2s-react-lm:components/content-cards': ContentCards,
    'br2s-react-lm:components/content-link': ContentLink,
    'br2s-react-lm:components/content-section-header': ContentSectionHeader,
    'br2s-react-lm:components/divider': Divider,
    'br2s-react-lm:components/help-snippet': HelpSnippetAdapter,
    'br2s-react-lm:components/inline-alert': InlineAlertAdapter,
    'br2s-react-lm:components/inline-state-indicator': InlineStateIndicator,
    'br2s-react-lm:components/link-cards': LinkCards,
    'br2s-react-lm:components/numbered-label-section-header': NumberedLabelSectionHeader,
    'br2s-react-lm:components/instruction-intro-header': InstructionIntroHeaderAdapter,
    'br2s-react-lm:components/instruction-intro-details': InstructionIntroDetailAdapter,
    'br2s-react-lm:components/scroll-anchor': ScrollAnchor,
    'br2s-react-lm:components/tooltip': Tooltip,
    'br2s-react-lm:components/typography': Typography,
    'br2s-react-lm:components/rich-text': Richtext,
    'br2s-react-lm:components/file-selector': FileSelector,
    'br2s-react-lm:components/image': Image
  },
};

export default config;
